import { Typography } from '@bw/alloy-react';
import React from 'react';

const ExpressHeader: React.FC = () => {
  return (
    <div
      className="text-center d-flex flex-column gap-3"
      data-bw="express-header"
    >
      <Typography
        color="white"
        tag="div"
        className="largeTitle"
        style={{ fontSize: 72 }}
      >
        Ready. Set. Go.
      </Typography>
      <Typography color="white" variant="h3">
        Your ideas, our network. Let&apos;s see what we can do.
      </Typography>
    </div>
  );
};

export default ExpressHeader;
